import React, {Component} from 'react';
import { FlexboxGrid, Grid, Col} from 'rsuite';
import {withTranslation} from 'react-i18next';
import { swalAction } from '../../../lib/functions';

import Layout from '../../../components/Layout';
import TableList from '../../../components/TableList';

class Locations extends Component{
    constructor(props){
        super(props);
        this.deleteItem = this.deleteItem.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.newLocation = this.newLocation.bind(this);
        this.updateColumns = this.updateColumns.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.openDetails = this.openDetails.bind(this);
        this.getLocations = this.getLocations.bind(this);
        this.goToPlans = this.goToPlans.bind(this);
        this.getLocationTypes = this.getLocationTypes.bind(this);

        this.state = {
            columns:[
                {title:'type', name:'type',  visible:true, width:'8%'},
                {title:'name', name:'name',  visible:true, width:'12%'},
                {title:'address', name:'address',  visible:true, width:'40%'},
                {title:'reference', name:'reference',  visible:false, width:'10%'},
                {title:'city', name:'city',  visible:false, width:'10%'},
                {title:'state', name:'state',  visible:false, width:'10%'},
                {title:'postal_code', name:'postal_code',  visible:false, width:'10%'},
                {title:'latitude', name:'latitude',  visible:true, width:'7%'},
                {title:'longitude', name:'longitude',  visible:true, width:'7%'},
                {title:'country', name:'country',  visible:true, width:'7%'},
                {title:'actions', name:'actions', visible:true, width:'120px'}
            ],
            data:[],
            locationsTypes:[],
            actions:[
                {
                    btn:true,
                    icon:'search',
                    title:this.props.t('button.details'),
                    clickFn:'details',
                    action: this.openDetails
                },
                {
                    btn:true,
                    icon:'edit',
                    title:this.props.t('button.edit'),
                    clickFn:'edit',
                    action: this.openEdit
                },
                {
                    btn:true,
                    icon:'trash-o',
                    title:this.props.t('button.delete'),
                    clickFn:'delete',
                    action: this.confirmDelete
                }
            ],
            lang:""
        }
    }

    async componentDidMount(){
        await this.setState({lang:sessionStorage.getItem(btoa("lang"))})
        var columnsLocation = sessionStorage.getItem('columnsLocation');
        // Si el número de columnas guardado no coincide con el de la
        // definición actual (p. ej. quedó cacheado de una versión anterior
        // del código con más/menos columnas), DataTables truena al montar
        // ("Incorrect column count") — se descarta el caché y se usa el
        // default fresco en vez de confiar ciegamente en lo guardado.
        if(columnsLocation === null || JSON.parse(columnsLocation).length !== this.state.columns.length){
            sessionStorage.setItem('columnsLocation', JSON.stringify(this.state.columns));
        }else{
            // Sólo se respeta la visibilidad guardada (lo único que el
            // usuario puede elegir desde el dropdown "Columnas") — título/
            // nombre/ancho siempre vienen del default de arriba, para que un
            // ajuste de anchos en código no quede pisado por un caché viejo
            // con los anchos de la versión anterior.
            var cached = JSON.parse(columnsLocation);
            var merged = this.state.columns.map((col, i)=> ({...col, visible: cached[i].visible}));
            sessionStorage.setItem('columnsLocation', JSON.stringify(merged));
            this.setState({columns: merged});
        }

        await this.getLocationTypes();
        this.getLocations();
    }

    async componentDidUpdate(){
        var auxLang = sessionStorage.getItem(btoa("lang"));
        if(this.state.lang !== auxLang){
            await this.setState({lang:auxLang});
            this.getLocationTypes();
        }
    }

    goToPlans(){
        this.props.history.push("/subscription-plans");
    }

    async getLocations(){
        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);

        let req = {
            api:'accounts',
            method:'get',
            url:'locations/by-account/'+accountId,
            obj:null,
            requireToken:true,
            modal:this.props.modal_loader,
            message_modal:this.props.t('modal.spin.start')
        }

        let request = await this.props.fetchRequest(req);

        if(request !== undefined){

            let values = [];
            for (let index = 0; index < request.length; index++) {
                var type = this.state.locationsTypes.find(obj => {
                    return obj.key === request[index].type
                });


                let temp = [
                    type !== null && type !== undefined? type.value:"",
                    request[index].name,
                    request[index].address !== null? request[index].address.addressLine1:"",
                    request[index].address !== null? request[index].address.addressLine2:"",
                    request[index].address !== null? request[index].address.city:"",
                    request[index].address !== null? request[index].address.state:"",
                    request[index].address !== null? request[index].address.zipCode:"",
                    // Number(...) por si el registro se guardó con
                    // latitude/longitude como string (bug ya corregido en
                    // NewLocation.js, pero puede haber quedado algún
                    // registro viejo así) — .toFixed no existe en strings.
                    Number(request[index].latitude).toFixed(4),
                    Number(request[index].longitude).toFixed(4),
                    request[index].address !== null? request[index].address.country:"",
                    request[index].id
                ];

               values.push(temp);
            }

            var suscription = sessionStorage.getItem('suscription');
            var disabled = false;
            var message = 'new';

            if(values.length >= 1 && suscription === 'free'){
                disabled = true;
            }

            if(values.length >= 10 && suscription === 'Basic Account'){
                disabled = true;
            }

            this.table.setState({disabled_new: disabled, message: message});

            // setTable() tiene que correr después de que React ya haya
            // vuelto a renderizar el <tbody> con el nuevo "values" — de lo
            // contrario DataTables escanea filas de un render intermedio
            // ("Incorrect column count" / _DT_CellIndex undefined), como
            // pasaba tras eliminar una ubicación.
            this.setState({data:values}, ()=>{
                this.table.setTable();
            });
        }
    }

    async getLocationTypes(){

        this.setState({
            locationsTypes: await this.props.fetchRequest({
                api:'accounts', 
                url:'lookups/location_type/'+atob(this.state.lang)+"/ordered",
                requireToken:true
            })
       });	
    }

    confirmDelete(e, id){
        var obj = {
            title           : this.props.t('modal.alert.titles.alert'),
            text            : this.props.t('modal.alert.messages.delete_location'),
            icon            : 'warning',
            showConfirm     : true,
            showCancel      : true,
            textConfirm     : this.props.t('modal.alert.confirms.delete'),
            colorConfirm    : '#3085d6',
            colorCancel     : '#d33',
            textcancel      : this.props.t('modal.alert.confirms.cancel'),
            values          : id,
            fn              : this.deleteItem
        }
        swalAction(obj);
    }

    async deleteItem(id){
        let req = {
            api:'accounts',
            method:'delete',
            url:'locations/'+id,
            obj:null,
            requireToken:true,
            modal:this.props.modal_loader,
            message_modal:this.props.t('modal.spin.start')
        }

        let request = await this.props.fetchRequest(req);

        if(request !== undefined){
            setTimeout(()=>{
                this.table.resetTable();
                this.getLocations();
            }, 300);
            
        }else {
            //Alert.error("Error al borrar");
            setTimeout(()=>{
                this.table.resetTable();
                this.getLocations();
            }, 300);
        }
    }

    newLocation(){
        var suscription = sessionStorage.getItem('suscription');

        if((suscription === 'free' && this.state.data.length >= 1) || (suscription === 'Basic Account' && this.state.data.length >= 10)){
            this.verifySuscription();
        }else{
            this.props.history.push('/settings/locations/new');
        }
        
    }

    verifySuscription(){
        var obj = {
            title           : this.props.t('modal.alert.titles.suscription'),
            text            : this.props.t('modal.alert.messages.update_suscription'),
            icon            : 'warning',
            showConfirm     : true,
            showCancel      : true,
            textConfirm     : this.props.t('modal.alert.confirms.go_plans'),
            colorConfirm    : '#3085d6',
            colorCancel     : '#d33',
            textcancel      : this.props.t('modal.alert.confirms.cancel'),
            values          : '',
            fn              : this.goToPlans
        }
        swalAction(obj);  
    }

    openEdit(e, id){
        this.props.history.push({
			pathname: '/settings/locations/edit/'+id
		});
    }

    openDetails(e, id){
        this.props.history.push({
			pathname: '/settings/locations/details/'+id
		});
    }

    updateColumns(e, i){
        var columns = this.state.columns;

        columns[i].visible = e.target.checked;

        sessionStorage.setItem('columnsLocation', JSON.stringify(columns));

        this.setState({columns: columns});
    }

    render(){
        const {t} = this.props;
        return (
            <div>
                <Layout {...this.props}>
                    <h3 className="s-title-page">{t('screen.settings.location.list.title')}</h3>
                    <Grid fluid>
                        <FlexboxGrid justify="center">
                            <Grid fluid style={{width:'100%'}}>
                                <Col xs={24}>
                                    <TableList 
                                        {...this.props}
                                        onRef={ref => this.table = ref}
                                        columns={this.state.columns}
                                        btnNew={true}
                                        data={this.state.data}
                                        actions={this.state.actions}
                                        updateColumns={this.updateColumns}
                                        new={this.newLocation}
                                        screen={"location"}
                                        report={false}
                                        scroll={true}
                                        scrollY="calc(100vh - 250px)"
                                    />
                                </Col>
                            </Grid>
                        </FlexboxGrid>
                    </Grid>
                </Layout>
            </div>
        )
    }
}

export default withTranslation('translations') (Locations);